import React, { useState } from 'react';
import { X } from 'lucide-react';
import './Gallery.css';

const galleryImages = [
  {
    url: 'https://images.unsplash.com/photo-1704455306925-1401c3012117?crop=entropy&cs=srgb&fm=jpg&q=85',
    alt: 'Modern treatment room'
  },
  {
    url: 'https://images.unsplash.com/photo-1704455306251-b4634215d98f?crop=entropy&cs=srgb&fm=jpg&q=85',
    alt: 'Dental clinic interior'
  },
  {
    url: 'https://images.unsplash.com/photo-1642844819197-5f5f21b89ff8?crop=entropy&cs=srgb&fm=jpg&q=85',
    alt: 'Professional dental equipment'
  },
  {
    url: 'https://images.unsplash.com/photo-1759038085950-1234ca8f5fed?crop=entropy&cs=srgb&fm=jpg&q=85',
    alt: 'Luxury reception area'
  },
  {
    url: 'https://images.unsplash.com/photo-1761232263616-dd580e7ce9be?crop=entropy&cs=srgb&fm=jpg&q=85',
    alt: 'Modern check-in area'
  },
  {
    url: 'https://images.pexels.com/photos/7108317/pexels-photo-7108317.jpeg',
    alt: 'Professional dental team'
  }
];

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <section id="gallery" className="gallery-section section-padding">
      <div className="container">
        <div className="gallery-header fade-in">
          <h2 className="heading-1">Our Clinic Gallery</h2>
          <div className="section-divider"></div>
          <p className="body-large gallery-subtitle">
            Take a virtual tour of our modern facilities
          </p>
        </div>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              className="gallery-item fade-in" 
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => openLightbox(image)}
            >
              <img src={image.url} alt={image.alt} className="gallery-image" />
              <div className="gallery-overlay">
                <span className="gallery-overlay-text">View Image</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <X size={32} />
          </button>
          <img 
            src={selectedImage.url} 
            alt={selectedImage.alt} 
            className="lightbox-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;